import { axiosInstance } from '../api';

export default function(activationCode) {
    return axiosInstance.post('/api/auth/registrationConfirmation', null, {
        params: {
            activationCode
        }
    });
}